export * from "./LocatorKeys";
export { default as VectorObjectLocator } from "./VectorObjectLocator.vue";
export { default as RectangleObjectLocator } from "./RectangleObjectLocator.vue";
export { default as RectangleObjectLocators } from "./RectangleObjectLocators.vue";
export { default as PositionCorrectionObjectLocator } from "./PositionCorrectionObjectLocator.vue";
